import(/* webpackMode: "eager" */ "/root/elawphant/src/app/[locale]/kupit-ooo/page.tsx");
